import { __assign, __awaiter, __generator, __read, __spreadArray, __values } from "tslib";
import axios from 'axios';
import { tdw } from '@tencent/tencent-doc-report';
import { decomposeAid } from './get-and-decompose-aid';
var DEFAULT_AID_SELECTOR_VALUE = 'default';
/**
 * 类比css选择器权重，预留aid各个字段的配置权重设置功能
 * https://www.sojson.com/operation/css.html
 */
var AID_SELECTOR_WEIGHTS = {
    prefix: 1,
    system: 1,
    plat: 1,
    position: 1,
    feature: 1,
    apprec1: 1,
    apprec2: 1,
    apprec3: 1,
};
var MultidimensionalConfigForAid = /** @class */ (function () {
    function MultidimensionalConfigForAid(params) {
        this.wuJiDBConfig = params.wuJiDBConfig;
    }
    MultidimensionalConfigForAid.prototype.get = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTheOneWithHighestPriority(params)];
                    case 1:
                        res = _a.sent();
                        tdw({
                            opername: 'MultidimensionalConfigForAid',
                            module: 'txdocsAid',
                            action: 'get',
                            wuJiDBConfig: JSON.stringify(this.wuJiDBConfig),
                            aid: params.aid,
                            res: JSON.stringify(res),
                        });
                        return [2 /*return*/, res];
                }
            });
        });
    };
    MultidimensionalConfigForAid.prototype.getTheOneWithHighestPriority = function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var destructedAid, filterInString, data, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        destructedAid = decomposeAid(params.aid);
                        if (!destructedAid) {
                            return [2 /*return*/, undefined];
                        }
                        filterInString = this.getFilterByAid(destructedAid);
                        if (!filterInString) {
                            return [2 /*return*/, undefined];
                        }
                        if (params === null || params === void 0 ? void 0 : params.extra) {
                            filterInString = "" + filterInString + this.getExtraFilter(params.extra);
                        }
                        return [4 /*yield*/, this.getDataFromWuJi({
                                size: 'total',
                                filter: filterInString,
                            })];
                    case 1:
                        data = ((_b.sent()) || {}).data;
                        if (!(data === null || data === void 0 ? void 0 : data.length)) {
                            return [2 /*return*/, undefined];
                        }
                        res = (_a = this.findTheLineHasMostPriority({ lines: data, destructedAid: destructedAid })) === null || _a === void 0 ? void 0 : _a[0];
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 找出优先级最高的那行配置
     * 优先级规则
     * 1. 命中的 aid 配置的权重总和，权重值越高，优先级越高
     * 2. priority 字段配置的优先级，数字越大优先级越高
     * 3. 配置的 自增id，id越大优先级越高 （越晚配置的越优先）
     * @param lines
     */
    MultidimensionalConfigForAid.prototype.findTheLineHasMostPriority = function (params) {
        var _this = this;
        var lines = params.lines, destructedAid = params.destructedAid;
        if (!lines.length) {
            return undefined;
        }
        var newLines = __spreadArray([], __read(lines));
        newLines.sort(function (a, b) {
            /**
             * 规则 1
             */
            var weightDiff = _this.countWeightOfLine({ line: b, destructedAid: destructedAid }) - _this.countWeightOfLine({ line: a, destructedAid: destructedAid });
            if (weightDiff !== 0) {
                return weightDiff;
            }
            /**
             * 如果规则 1 的优先级相同，再用规则 2 排序
             */
            var priorityDiff = (b.priority || 0) - (a.priority || 0);
            if (priorityDiff !== 0) {
                return priorityDiff;
            }
            /**
             * 如果规则 2 的优先级相同，再用规则 3 排序
             */
            return b.id - a.id;
        });
        return newLines;
    };
    MultidimensionalConfigForAid.prototype.countWeightOfLine = function (params) {
        var line = params.line, destructedAid = params.destructedAid;
        var cnt = 0;
        Object.keys(AID_SELECTOR_WEIGHTS).forEach(function (k) {
            if (line[k] !== DEFAULT_AID_SELECTOR_VALUE && line[k] === destructedAid[k]) {
                cnt += AID_SELECTOR_WEIGHTS[k];
            }
        });
        return cnt;
    };
    MultidimensionalConfigForAid.prototype.getFilterByAid = function (destructedAid) {
        var filter = Object.entries(destructedAid).reduce(function (pre, curr) {
            var _a = __read(curr, 2), k = _a[0], v = _a[1];
            pre[k] = [DEFAULT_AID_SELECTOR_VALUE];
            if (v) {
                pre[k].push(v);
            }
            return pre;
        }, {});
        var filterInString = Object.entries(filter)
            .map(function (curr) {
            var _a = __read(curr, 2), k = _a[0], v = _a[1];
            var s = k;
            s = s + "=[" + v.map(function (subS) { return "\"" + subS + "\""; }).join(',') + "]";
            return s;
        })
            .join('&');
        return filterInString;
    };
    MultidimensionalConfigForAid.prototype.getDataFromWuJi = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get('https://v.qq.com/cache/wuji/object', {
                                params: __assign(__assign({}, this.wuJiDBConfig), params),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                    case 2:
                        e_1 = _a.sent();
                        console.error('从无极拉取数据失败，请检查参数： params', params);
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MultidimensionalConfigForAid.prototype.getExtraFilter = function (extra) {
        var e_2, _a;
        var filterInString = '';
        try {
            try {
                for (var _b = __values(Object.keys(extra)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    filterInString = filterInString + "&" + key + "=[\"default\",\"" + extra[key] + "\"]";
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        catch (e) { }
        return filterInString;
    };
    return MultidimensionalConfigForAid;
}());
export { MultidimensionalConfigForAid };
